<template>
    <div>
        <preloader v-if="isLoading || !isInit"/>
        <div v-else class="transaction">
            <div class="transaction__head-wrapper">
                <AtButton
                  class="transaction__all"
                  type="primary"
                  icon="icon-arrow-left"
                  @click="goBack"
                >

                    <span class="transaction__head-title" >{{ $t('transaction.return') }}</span>
                </AtButton>
                <h1 class="title">
                    {{ $t('historyAddresses.information') }}
                </h1>
            </div>

            <template v-if="hasTransaction">
                <HistoryAddressInfo
                  class="transaction__info"
                  :data="transaction"
                />
            </template>
        </div>

    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import AtButton from 'at-ui/src/components/button';
import HistoryAddressInfo from "../components/elements/history-addresses/HistoryAddressInfo";
import Preloader from "/public/components/common/uiKit/spinner/index.vue";

export default {
    name: 'HistoryAddress',
    title: 'historyAddresses.information',
    components: {
        Preloader,
        HistoryAddressInfo,
        AtButton,
    },
    data() {
        return {
            transaction: null,
        };
    },
    computed: {
        ...mapState('app', ['isInit', 'isLoading']),
        transactionId() {
            return this.$route.params.id;
        },
        hasTransaction() {
            return Boolean(this.transaction);
        },
        type() {
            return this.transaction.type;
        },
        isDeposit() {
            return this.type === 'deposit';
        },
        isExchange() {
            return this.type === 'exchange';
        },
        isWithdraw() {
            return this.type === 'withdrawal';
        },
    },
    beforeMount() {
        this.setTransaction();
    },
    methods: {
        ...mapActions('historyAddresses', [
            'getCurrentAddress',
        ]),
        setTransaction() {
            const {
                transactionId,
                getCurrentAddress,
            } = this;

            getCurrentAddress({
                id: transactionId,
            })
                .then(transaction => {
                    this.transaction = transaction;
                });
        },
        goBack() {
            if (window.history.length > 2) this.$router.go(-1);
            else this.$router.push({name: 'historyAddresses'});
        },
    },
};

</script>

<style lang="scss" scoped>

.title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 42px;
  color: var(--primary-font-color);
  margin-top: 30px;
  margin-bottom: 18px;
  width: 100%;
}

.transaction {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: var(--padding-left-container);
  padding-right: var(--padding-right-container);
  padding-top: var(--padding-top-container);

  &__info {
    margin-bottom: var(--margin-container-bottom);
    margin-top: var(--margin-container-top);
  }

  &__head-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__all {
    background: #0059F7;
    border-radius: 6px;
    border: none;
    width: 100%;
    max-width: 125px;
    min-height: 40px;
    align-self: flex-start;
    transition: all 0.3s ease-in;

    &:hover {
      background: var(--blue-400);
    }

    ::v-deep .at-btn__text {
      font-family: var(--font-family);
      font-size: var(--font-size-text-main);
      line-height: var(--line-height);
      color: var(--white-100);
    }

    ::v-deep .at-btn__icon {
      font-size: var(--font-size-text-main);
    }
  }

  &__title {
    margin-bottom: 24px;
    min-height: 107px;
  }
}


@media screen and (max-width: 1180px) {
  .transaction {
    &__all {

    }
  }

}

@media screen and (max-width: 950px) {
  .title {
    font-size: 20px;
    line-height: 23px;
    margin: 0;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .transaction {
    padding-left: 20px;
    padding-right: 20px;

    &__head-wrapper {
      flex-direction: unset;
    }

    &__head-title {
      display: none;
    }

    &__all {
      background: transparent;
      padding: 0;
      width: 20px;

      ::v-deep .at-btn__icon {
        font-size: 20px;
        color: #0059F7;
      }
    }
  }
}

@media screen and (max-width: 375px) {
  .transaction {
    padding-right: 0;
    padding-left: 0;

    &__all {
      margin-left: 10px;
    }
  }

}
</style>
